import { render, staticRenderFns } from "./SupplierSelect.vue?vue&type=template&id=0d2540c8&"
import script from "./SupplierSelect.vue?vue&type=script&lang=js&"
export * from "./SupplierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports